<app-user-header class="d-lg-none"></app-user-header> 

<div class="wrapperi">
    <div class="col-12 ps-3">
        <p class="semiboldtextblue24 mt-4">Asetukset</p>
    </div>
<div class="col-12 ps-3 pe-3 pb-4">
    <div class="formed-shadow pt-4 ps-2 pe-2 pb-4">
        <div class="tab">
            <button class="tablinks active" (click)="openCity($event, 'details')">Tiedot</button>
            <button class="tablinks" (click)="openCity($event, 'places')">Toimipisteet</button>
            <button class="tablinks" (click)="openCity($event, 'users')">Käyttäjät</button>
            <button class="tablinks" routerLink="/{{businessID}}/company-billing">Maksuhistoria</button>
<!--             <button class="tablinks" (click)="openCity($event, 'support')">Tuki</button>
 -->          </div>
      <div class="col-12 row m-0 tabcontent" id="details" style="display: block;" *ngIf="company.length >0">
        <div class="col-12">

            <div *ngIf="company[0]['mobile_banner_image']" 
            class="cover-image" 
            [style.background-image]="'url(' + company[0]['mobile_banner_image'] + ')'">
            <div class="logo-container" *ngIf="company[0].logo">
                <img src="{{company[0].logo}}" class="logo-class" alt=""/>
            </div>
                <div class="logo-container" *ngIf="!company[0].logo">
                    <p class="semiboldtextblue18">{{company[0].businessName}}</p>
                    <a class="btn btn-formed-main-blue" routerLink="/{{businessID}}/edit-business"><i class="fas fa-edit me-2"></i>Lisää logo</a>
    
                </div>
            </div>
            <div *ngIf="!company[0]['mobile_banner_image']" 
            class="cover-image" 
            [style.background-image]="'url(../../assets/images/no_mobile_cover.jpg)'">
            <div class="logo-container">
                <div class="" *ngIf="company[0].logo;else no_logo_added">
                    <img src="{{company[0].logo}}" height="80" alt="">
                </div>
                <ng-template #no_logo_added>
                    <p class="semiboldtextblue18">{{company[0].businessName}}</p>
                    <a class="btn btn-formed-main-blue" routerLink="/{{businessID}}/edit-business"><i class="fas fa-edit me-2"></i>Lisää logo</a>

                </ng-template>
                
            </div>
            </div>
        </div>
        <div class="col-12">
            <div class="col-12 ps-2">
                <div class="d-flex justify-content-between">
                    <p class="semiboldtextblue24 mt-4">{{company[0].businessName}}</p>

                    <button class="btn btn-formed-main-blue mt-4" routerLink="/{{businessID}}/edit-business"><i class="fas fa-edit me-2"></i>Muokkaa</button>

                </div>
            </div>


        </div>
        <div class="col-12 row m-0 ps-0 mt-4">
            <div class="col-xl-7 h-100">
                <div class="bg-f-b p-4 h-100">
                    <p class="normaltextblue30016">Kuvaus</p>
                    <div *ngIf="company[0].description;else no_desc" class="">
                        <p class="normaltextblue80016 allow-line-breaks">{{company[0].description}}</p>
                    </div>
                    <ng-template #no_desc>
                        <a routerLink="/{{businessID}}/edit-business" >+ Lisää kuvaus</a>
                    </ng-template>


                </div>

            </div>
            <div class="col-xl-5 pe-2 ps-md-0 mt-4 mt-md-0 ">
                <div class="h-100">
                    <div class=""*ngIf="company[0].description_video_url;else no_video_content">
                        <iframe class="formed-video" id="video" title="Video" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" allowfullscreen></iframe>       

                    </div>
                    <ng-template #no_video_content>
                        <div class="p-4">
                            <p class="normaltextblue30016">Youtube Video</p>
                            <a routerLink="/{{businessID}}/edit-business" >+ Lisää video</a>

                        </div>

                    </ng-template>
                </div>
            </div>
        </div>
    </div>
    <div class="tabcontent" id="places">
        <div class="ps-4 pt-0 pe-4 pb-4">
            <div class="">
                <div class="d-block d-md-flex justify-content-between">
                    <div class="">
                        <p class="semiboldtextblue24 mt-2">Toimipisteet</p>
                        <button class="btn btn-formed-main-blue mb-3" routerLink="/{{businessID}}/subgroups/add-subgroup"><i class="fa fa-plus-circle me-2"></i>Lisää toimipiste</button>
                    </div>
                    <div class="mt-3 mb-3 mt-md-0 mt-md-0">
                    </div>
                </div>
            </div>
            <div class="formed-list bg-f-b pt-3 pb-3" *ngFor="let data of subGroups">
                <div class="col-12 row m-0">
                    <div class="col-12 col-md-9">
                        <div class="col-12 row">
                            <div class="col-12 col-md-7 ps-0 pe-0 ps-md-2 pe-md-2">
                                <div class="d-inline-flex">
                                    <img class="d-none d-md-block"src="../../assets/icons/company_icon_blue.svg" alt="">
                                    <div class="ps-0 ps-md-4">
                                        <p class="normaltextblue80016 mb-0">Nimi</p>
                                        <p class="semiboldtextblue80016 mb-0">{{data.businessName}}</p>
        
                                    </div>
                                </div>
                            </div>
                            <div class="col-12 col-md-5 ps-0 pe-0 ps-md-2 pe-md-2">
                                <div class="text-start">
                                    <p class="normaltextblue80016 mb-0">Osoite</p>
                                    <p class="semiboldtextblue80016 mb-0">{{data.address}}</p>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="col-12 col-md-3 mt-3 mt-md-0 ps-0 pe-0 ps-md-2 pe-md-2">
                        <div class="d-flex justify-content-md-end">
                            <button class="btn btn-formed-thin-blue me-4" routerLink="/{{businessID}}/subgroups/edit-subgroup/{{data._id}}"><i class="fas fa-edit me-2"></i>Muokkaa</button>
                            <button (click)="selectSubGroup(data._id)" data-bs-toggle="modal" data-bs-target="#delete-confirm-modal" class="btn btn-formed-thin-red" ><i class="fas fa-trash-alt me-2"></i>Poista</button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
    <div class="tabcontent" id="users">
        <div class="col-12">
            <div class="ps-4 pt-0 pe-4 pb-4">
                <div class="">
                    <div class="d-flex justify-content-between">
                        <div class="align-items-center">
                            <p class="semiboldtextblue24 mt-2">Käyttäjät</p>
                            <button class="btn btn-formed-main-blue mb-3" routerLink="/{{businessID}}/register-user"><i class="fa fa-plus-circle me-2"></i>Lisää käyttäjä</button>
                        </div>
                        <div class="mt-3 mb-3 mt-md-0 mt-md-0">
                        </div>
                    </div>
                </div>
                <div class="row">
                    <div class="col-12" *ngFor="let data of users">
                        <div class="formed-list" [ngClass]="data.mainUser ? 'bg-f-w formed-shadow' : 'bg-f-b'">
                            <div class="p-2">
                                <div class="col-12 row m-0 p-0">
                                    <div class="col-12 col-md-4 p-0">
                                        <div class="d-inline-flex">
                                            <div class="pe-2" *ngIf="!data.profilePicture; else pic_added">
                                                <img class="rounded-circle" [ngClass]="data.mainUser ? 'golden-radius' : ''" src="../../assets/icons/formed_no_profile.svg" height="50" alt="">
                                            </div>
                                            <ng-template #pic_added>
                                                <div class="pe-2">
                                                    <img class="rounded-circle" [ngClass]="data.mainUser ? 'golden-radius' : ''" src="{{data.profilePicture}}" height="50" alt="">

                                                </div>
                                            </ng-template>
                                            <div class="d-flex flex-column align-self-center">
                                                <p class="formed-sub-title mb-0">{{data.firstName}} {{data.lastName}}
                                                    <span title="Aktivointikoodia ei aktivoitu määräajassa" *ngIf="data.isExpired">
                                                        <img height="20" width="20" src="../../assets/icons/alert.svg" alt="">
                                                    </span>
                                                </p>
                                                <div *ngIf="data.mainUser" class="">
                                                    <p class="admin-text mb-0">Oma profiili</p>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="col-12 col-md-6 p-0">
                                        <div class="d-flex align-items-center h-100">
                                            <p class="normaltextblue80016 mb-0">{{data.email}}</p>
                                        </div>
                                    </div>
                                    <div class="col-12 col-md-2 p-0">
                                        <div class="d-flex align-items-center h-100">
                                            <button routerLink="/{{businessID}}/user-details/{{data._id}}" class="btn btn-formed-main-blue mt-1"><i class="fa fa-info-circle pe-2"></i>Tiedot</button>

                                        </div>
                                    </div>
                                </div>
                            </div>
                            </div>
                        </div>
    
                    </div>
                </div>
            </div>
    </div>
    <div class="tabcontent" id="support">
        <div class="ps-4 pt-0 pe-4 pb-4">
            <p class="semiboldtextblue24 mt-4">Formed tuki</p>
            <div 
            class="cover-image-support" 
            [style.background-image]="'url(../../assets/images/banner.png)'">
            </div>
        </div>
        <div class="justify-content-center d-flex margin-top">
        </div>
        <div class="justify-content-center d-flex flex-column mt-4 pb-4 mb-4">
            <p class="semiboldtextblue20 text-center">Miro Hämynen</p>
            <a class="text-center" href="mailto:miro.hamynen@formed.fi">miro.hamynen&#64;formed.fi</a>
        </div>
    </div>
    </div>
</div>
</div>




        <!-- Modal Check before deleting offer -->
        <button data-bs-toggle="modal" id="delete-confirm" data-bs-target="#delete-confirm-modal" style="display:none"></button>
        <div class="modal fade" id="delete-confirm-modal" tabindex="-1" role="dialog" aria-labelledby="exampleModalLabel" aria-hidden="true">
        <div class="modal-dialog" role="document">
            <div class="modal-content">
            <div class="modal-header">
                <h5 class="text-center w-100" id="exampleModalLabel">Toimipisteen poistaminen</h5>
                <!-- <p>Kaikki tähdellä merkityt kentät ovat pakollisia</p> -->
                <button id="close-confirm-modal-subgroup" type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close">

                </button>
            </div>
            <div class="modal-body">
                <div class="" *ngIf="!deleteLoader">
                    <p class="text-center">Oletko varma, että haluat poistaa pysyvästi toimipisteen? Huomaathan, että sinun tulee poistaa ensiksi kaikki toimipisteen työpaikkailmoitukset.</p>
                    <div class="text-center justify-content-center d-flex col-12 mt-4 pt-4 ">
                      <button class="btn btn-formed-delete" (click)="removeSubGroup()"><i class="fa fa-trash-alt me-2"></i>Poista toimipiste</button>
                  </div>

                </div>
                <div id="loader" class="loader-container mt-4" *ngIf="deleteLoader">
                    <div class="loader mx-auto"></div>
                    <p class="text-center pt-3">Tietoja poistetaan...</p>
                  </div>
                



            </div>
            </div>
        </div>
        </div>
